import React, { useState } from 'react'
import googleLogoutImage from '../../assets/logos/google_logout_button.png'
import { googleLogout } from '@react-oauth/google'
import { logoutProfile, chatReset, resetApp, persistor } from '../../store'
import AlertMessage from './AlertMessage'
import { useDispatch, useSelector } from 'react-redux' // Import useDispatch hook

const Logout = ({ goToAuthorisation }) => {
  const [showAlert, setShowAlert] = useState(false)
  const dispatch = useDispatch()
  const agentData = useSelector((state) => state.agentData)

  const language = useSelector((state) => state.language) // Get language from Redux store
  const translations = useSelector((state) => state.translationsData) || {}
  const getTranslationText = (
    keyPath,
    data = translations,
    lang = language.toUpperCase(),
  ) => {
    const keys = keyPath.split('.') // Split the keyPath into an array of keys

    // Traverse the data object using the keys
    let result = data
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]

      // Handle arrays (e.g., intro or questions)
      if (Array.isArray(result)) {
        const found = result.find((item) => item.label === key)
        if (!found) {
          return undefined // Return undefined if the label is not found
        }
        result = found
      } else if (result[key] === undefined) {
        return undefined // Return undefined if the path is not found
      } else {
        result = result[key]
      }
    }

    // If the result is an object with language keys, return the value for the specified language
    if (
      typeof result === 'object' &&
      !Array.isArray(result) &&
      result[lang] !== undefined
    ) {
      return result[lang]
    }

    // Otherwise, return the result as is
    return result
  }

  const confirmAlert = getTranslationText(
    'filterProduct.confirmationAlert.alert.text',
  )
  const confirmAlertText = getTranslationText(
    'filterProduct.confirmationAlert.alert.subtext',
  )

  const handleLogoutClick = async () => {
    if (agentData.platform === 'Google') {
      googleLogout()
      logoutProfile()
    } else {
      window.FB.logout(function (response) {
        return {}
      })
      logoutProfile() // Clear your Redux store
    }
    dispatch(resetApp())
    try {
      await persistor.purge()
    } catch (err) {
      console.error('Persistor purge failed during logout', err)
    }
    setShowAlert(true)
  }

  return (
    <div>
      {showAlert && (
        <AlertMessage
          message={confirmAlert}
          subtext={confirmAlertText}
          onConfirm={() => {
            goToAuthorisation()
            setShowAlert(false)
          }} // Log out only if "Oui" is clicked
          onCancel={() => {
            setShowAlert(false)
          }} // Close alert if "Non" is clicked
        />
      )}
      <div className='logout-button' onClick={handleLogoutClick}>
        <img
          src={agentData?.agentProfilePicture}
          alt='Sign Out'
          className='logout-image'
        />
      </div>
    </div>
  )
}

export default Logout
